import expensePosting from '@/api/expense/expense-posting'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')],
  expenseType: [],
  employeeId: [],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_EXPENSE_TYPE(state, date) {
    state.expenseType = date
  },
  SET_EMPLOYEE_ID(state, date) {
    state.employeeId = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_filter: _.join(context.state.dateRange, ','),
          expense_type: context.state.expenseType,
          employee_id: context.state.employeeId,
        }
      },
      attrubutes
    )
    return expensePosting.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return expensePosting.store(data)
  },
  update(context, { id, data }) {
    return expensePosting.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await expensePosting.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return expensePosting.destroy(id)
  },
  upload(context, data) {
    return expensePosting.upload(data)
  },
  toPdf(context, id) {
    return expensePosting.toPdf(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await expensePosting.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}